import axios from 'axios';
import prepareQueryString from '@/utils/prepareQueryString';
import { subject as an } from '@casl/ability';
import { adminPath } from '@/api/helpers/apiPath';

export default {
  getGlCodes(params) {
    return axios.get(adminPath('/gl_codes?') + prepareQueryString(params)).then((response) => {
      return {
        glCodes: response.data.map((glCode) => an('GLCode', glCode)),
        total: response.headers['x-pagination'] && JSON.parse(response.headers['x-pagination']).total,
      };
    });
  },
  update(id, data) {
    return axios
      .patch(adminPath(`/gl_codes/${id}`), {
        ...data,
      })
      .then((response) => an('GLCode', response.data));
  },
  create(data) {
    return axios
      .post(adminPath('/gl_codes'), {
        ...data,
      })
      .then((response) => an('GLCode', response.data));
  },
  getSpreadsheet(params) {
    return axios.get(adminPath('/gl_codes.csv?') + prepareQueryString(params), { responseType: 'blob' });
  },
};
